import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, tap, withLatestFrom, exhaustMap, concatMap } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import * as usersActions from '../store/actions/users.action';
import * as usersSelectors from '../store/selectors/users.selector';
import { UsersServerService } from '../services/users.service';
import { EMPTY, of } from 'rxjs';
import { User } from '../models/users.model';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Injectable()
export class UsersEffects {

    constructor(
        private actions$: Actions,
        private usersService: UsersServerService,
        private store: Store<{ user: User }>,
        private toastr: ToastrService,
        private router: Router
    ) {}

    loadUsers$ = createEffect(() => this.actions$.pipe(
        ofType(usersActions.loadUsers),
        exhaustMap((action) =>
            this.usersService.getUsers(action.page, action.limit, action.query)
            .pipe(
            map(users => usersActions.loadUsersSuccess({ users })),
            catchError((error) => {
                console.error('Error loading users', error);
                this.toastr.error('No se pudieron cargar los usuarios');
                return EMPTY;
            })
            ))
        )
        );

       updatedUser$ = createEffect(() => this.actions$.pipe(
        ofType(usersActions.updatedUser),
        tap(() => {
            this.store.select(usersSelectors.selectUser).subscribe(user => {
                console.log('updatedUser', user);
            });
        }),
            catchError(() => EMPTY)
        ), { dispatch: false });

        createUser$ = createEffect(() => 
            this.actions$.pipe(
                ofType(usersActions.createUser),
                withLatestFrom(this.store.pipe(select(usersSelectors.selectUser))),
                mergeMap(([action, user]) =>
                    this.usersService.createUser(user).pipe(
                        map((order) => {
                            this.toastr.success('Usuario creado');
                            this.router.navigate(['/users']);
                            return usersActions.createUserSuccess({ user: order });
                        }),
                        catchError((error) => {
                            console.error('Error creating user', error);
                            this.toastr.error('No se pudo crear el usuario');
                            return of(usersActions.createUserFailure({ error }));
                        })
                    )
                )
            )
        );

        editUser$ = createEffect(() =>
            this.actions$.pipe(
                ofType(usersActions.editUser),
                withLatestFrom(this.store.pipe(select(usersSelectors.selectUser))),
                mergeMap(([action, user]) =>
                    this.usersService.editUser(user).pipe(
                        map((user) => {
                            this.toastr.success('Usuario actualizado');
                            this.router.navigate(['/users']);
                            return usersActions.editUserSuccess({ user });
                        }),
                        catchError((error) => {
                            console.error('Error editing user', error);
                            this.toastr.error('No se pudo actualizar el usuario');
                            return of(usersActions.editUserFailure({ error }));
                        })
                    )
                )
            )
        );

         loadUserById$ = createEffect(() => this.actions$.pipe(
            ofType(usersActions.loadUserById),
            mergeMap(({ id }) =>
                this.usersService.getUserById(id).pipe(
                    map(user => {
                        console.log('User loaded by ID:', user);
                       return  usersActions.loadUserByIdSuccess({ user })
                    } ),
                    catchError((error) => of(usersActions.loadUserByIdFailure({ error })))
                )
            )
        ));
}